module.exports = __webpack_public_path__ + "img/google-play.2357e96f.svg";